import React, { useEffect } from 'react'
import { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Button, Modal, Form } from 'react-bootstrap'
import { clearMessage, addDictWord } from '../../../actions/wordsActions'
import Swal from 'sweetalert2'

function ModalDictionaryWord({
    showDictionaryWord,
    handleCloseDictionaryWord,
    handleUpdateDictionaryWord,
    dictWord
}) {
    const dispatch = useDispatch()
    const [problemWord, setProblemWord] = useState("")
    const [solutionWords, setSolutionWords] = useState("")
    const [title, setTitle] = useState("Add dictionary word")
    const [isEditing, setIsEditing] = useState(false)
    const message = useSelector(state => state.wordReducer.msg)

    const handleClose = () => {
        dispatch(clearMessage())
        handleCloseDictionaryWord()
    }

    const handleSubmit = () => {
        if (isEditing) {
            handleUpdateDictionaryWord(problemWord, solutionWords)
            handleCloseDictionaryWord()
        } else {
            dispatch(addDictWord(problemWord, solutionWords))
                .then(res => {
                    Swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: "Word added",
                        showConfirmButton: false,
                        timer: 1000
                    })
                    handleCloseDictionaryWord()
                })
                .catch(err => {
                    Swal.fire({
                        position: 'top-end',
                        icon: 'error',
                        title: "Failed to add word",
                        showConfirmButton: false,
                        timer: 1000
                    })
                })
        }
    }

    useEffect(() => {
        if (showDictionaryWord && dictWord) {
            setIsEditing(true)
            setTitle("Edit dictionary word")
            setProblemWord(dictWord.problem_word)
            setSolutionWords(dictWord.solution_words.join(', '))
        } else {
            setIsEditing(false)
            setProblemWord("")
            setSolutionWords("")
            setTitle("Add dictionary word")
        }
    }, [showDictionaryWord])

    return (
        <div>
            <Modal show={showDictionaryWord} onHide={() => handleClose()} aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header closeButton onClick={() => handleClose()}>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form noValidate>
                        <p>{message}</p>
                        <Form.Group>
                            <Form.Label>Wrong word</Form.Label>
                            <Form.Control
                                required
                                type="text"
                                value={problemWord}
                                placeholder="Enter wrong word"
                                onChange={
                                    (input) => setProblemWord(input.target.value)} />
                            <Form.Control.Feedback></Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Correct words</Form.Label>
                            <Form.Control
                                required
                                type="text"
                                value={solutionWords}
                                placeholder="Enter solution words separated with ','"
                                onChange={
                                    (input) => setSolutionWords(input.target.value)} />
                            <Form.Control.Feedback></Form.Control.Feedback>
                        </Form.Group>
                    </Form>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="primary" onClick={() => handleSubmit()}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default ModalDictionaryWord
